import { render, staticRenderFns } from "./CompraUpdate.vue?vue&type=template&id=d5a60e5c&scoped=true"
import script from "./CompraUpdate.vue?vue&type=script&lang=js"
export * from "./CompraUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a60e5c",
  null
  
)

export default component.exports